/**
 * Central registry of all emoticons available in the game.
 * The values correspond to the spritesheet IDs.
 */
export const EMOTICONS = {
  ANGRY: 'emoticon-angry',
} as const;

/**
 * Type representing all valid emoticon identifiers.
 */
export type EmoticonId = (typeof EMOTICONS)[keyof typeof EMOTICONS];

/**
 * Utility to get all registered emoticon IDs.
 */
export function getAllEmoticonIds(): EmoticonId[] {
  return Object.values(EMOTICONS);
}
